export enum AppEdition {
    Denmark,
    Norway,
}

let currentAppEdition = AppEdition.Denmark;

// The edition is fixed per deployment, so it is set once at app startup.
export const setCurrentAppEdition = (appEdition: AppEdition) => {
    currentAppEdition = appEdition;
};

export const getCurrentAppEdition = () => currentAppEdition;
